<template>
  <div>
    <el-alert
      v-if=copied
      title="Copied to clipboard"
      type="success">
    </el-alert>
    <el-alert
      v-if=error
      title="Something happened"
      type="error">
    </el-alert>
    <h2><em>Your friend wants to play!</em></h2>
    <div class="top-block">
      <h1>{{ this.title }}</h1>
      <div>To add this person use the friend code:</div>
      <el-card class="box-card" data-clipboard-action="copy" data-clipboard-target="div#code">
        <div id="code" value="this.code" >{{ this.code.replace(/([a-zA-Z0-9]{4})([a-zA-Z0-9]{4})([a-zA-Z0-9]{4})/, '$1-$2-$3') }}</div>
        <small>Click to copy</small>
      </el-card>
      <div class="link-home">
        <router-link to="/">Create your own link!</router-link>
      </div>
    </div>
  </div>
</template>

<style>
h2 {
  color: red;
}
a{
  color: white;
}
.el-card {
  max-width: 60%;
  margin: auto;
  background-color:white;
  margin: 1em 1em 1em 1em;
}
.el-card__body {
  padding: 0px;
}
h2 {
  margin: 0.7em 0.2em 0.4em 0.2em;
}
#code {
  font-size: 1.5em;
}
small {
  color: darkgray;
}
.link-home {
  margin-top: 0.6em;
}
</style>

<script>
import axios from '../services/axios';
import ClipboardJS from 'clipboard';

export default {
  name: "DisplayCode",
  data() {
    return {
      title: '',
      code: '',
      error: '',
      copied: false,
    };
  },
  created() {
    this.title = this.$route.params.key;
    axios.get(this.title.toLowerCase())
      .then((resp) => {
        switch (resp.status) {
          case 200:
            this.code = resp.data.code;
            break;
          default:
            this.code = 'unexpected response';
        }
      })
      .catch((rej) => {
        switch (rej.response.status) {
          case 404:
            this.code = 'Not found. Make one now!';
            break;
          case 400:
            this.code = 'something happened';
            break;
          default:
            this.error = 'unexpected response';
        }
      });
      var clipboard = new ClipboardJS('.box-card');
 
      clipboard.on('success', (e) => {
        this.copied = true;
        e.clearSelection();
      });

      clipboard.on('error', () => {
        this.error = 'Could not copy';
      });
  },
  methods: {
  },
}
</script>
